import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
        <li>
          <Link to="/" className="hover:text-primary-500 transition-colors duration-200">
            <i className="ri-home-4-line"></i>
            <span className="ml-1">首页</span>
          </Link>
        </li>
        {items.map((item, idx) => (
          <li key={idx} className="flex items-center gap-1">
            <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
            {item.path && idx < items.length - 1 ? (
              <Link to={item.path} className="hover:text-primary-500 transition-colors duration-200">
                {item.name}
              </Link>
            ) : (
              <span className={idx === items.length - 1 ? 'text-foreground-800 font-medium' : ''}>
                {item.name}
              </span>
            )}
          </li>
        ))}
      </ol>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://xiaocaoyingyuan.com/' },
              ...items.map((item, idx) => ({
                '@type': 'ListItem',
                position: idx + 2,
                name: item.name,
                ...(item.path ? { item: `https://xiaocaoyingyuan.com${item.path}` } : {}),
              })),
            ],
          }),
        }}
      />
    </nav>
  );
}